import firebaseApp from 'config/firebase/firebase-config';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
let messagingInstance: any = null;
export const initializeMessaging = async () => {
  try {
    if (!(await isSupported())) {
      console.log('Firebase messaging is not supported');
      return null;
    }

    messagingInstance = getMessaging(firebaseApp);
    return messagingInstance;
  } catch (error) {
    console.error('Error initializing messaging:', error);
    return null;
  }
};
export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    // Initialize messaging if not already done
    if (!messagingInstance) {
      await initializeMessaging();
    }

    // Ensure service worker is registered
    const registration = await registerServiceWorker();
    if (!registration) {
      console.error('Service worker registration failed');
      return null;
    }

    const currentToken = await getToken(messagingInstance, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('FCM Token obtained successfully');
      return currentToken;
    }

    console.log('No registration token available');
    return null;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

const registerServiceWorker = async () => {
  try {
    // Unregister existing service workers
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }

    // Register new service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/',
    });

    // Wait for the service worker to be ready
    await navigator.serviceWorker.ready;
    console.log('Service Worker registered successfully');
    return registration;
  } catch (error) {
    console.error('Service Worker registration failed:', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messagingInstance) {
      resolve(null);
      return;
    }
    onMessage(messagingInstance, (payload) => {
      resolve(payload);
    });
  });

// Only for test purposes
export const __setMessagingInstance = (val: any) => {
  messagingInstance = val;
};
